var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPlusBig = function SvgPlusBig(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177,
    height: 177,
    fill: "none",
    viewBox: "0 0 177 177",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DDE1E6",
    fillRule: "evenodd",
    d: "M76.437 0h23.913c2.989 0 5.338 2.349 5.338 5.124v66.188h66.188c2.775 0 5.124 2.349 5.124 5.125v23.913c0 2.989-2.349 5.338-5.124 5.338h-66.188v66.188c0 2.775-2.349 5.124-5.338 5.124H76.437c-2.776 0-5.125-2.349-5.125-5.124v-66.188H5.124C2.35 105.688 0 103.339 0 100.35V76.437c0-2.776 2.349-5.125 5.124-5.125h66.188V5.124C71.312 2.35 73.661 0 76.437 0",
    clipRule: "evenodd"
  })));
};
export default SvgPlusBig;